export default __webpack_public_path__ + "static/Taufik-60b55fba81ec963ad8edff4dc1cfe359.png";